import React from 'react';
import PropTypes from 'prop-types';
import Badge from '@visa/vds-react/badge-styled';
import BadgeDot from '@visa/vds-react/badge-dot';
import CybsIcon from '@visa/vds-react/icon';

import styles from './component.styles';

function CybsStatusBadge({ label, status, size, dataTest, icon, textOnly, ...rest }) {
  const type = {
    warning: 'warning',
    negative: 'critical',
    positive: 'stable',
    status: 'status',
    neutral: 'disabled' // should be named neutral in vds-react
  };
  return (
    <Badge
      customCSS={theme => styles(theme).badge}
      type={type[status]}
      size={size}
      {...rest}
    >
      {!textOnly && (icon
        ? <CybsIcon name={icon} resolution="tiny" />
        : <BadgeDot />)
      }
      {label}
    </Badge>
  );
}

CybsStatusBadge.displayName = 'CybsStatusBadge';
CybsStatusBadge.propTypes = {
  /**
   *  Date test.
   */
  dataTest: PropTypes.string.isRequired,
  /**
   * Badge Label
   */
  label: PropTypes.string.isRequired,
  /**
   * Badge size
   */
  size: PropTypes.oneOf(['small']),
  /**
   * One of: negative, neutral, positive, warning
   */
  status: PropTypes.oneOf(['negative', 'neutral', 'positive', 'warning', 'status']).isRequired,
  /**
   * Icon name (optional)
   */
  icon: PropTypes.string,
  /**
   * Flag to remove dot and icon (optional)
   */
  textOnly: PropTypes.bool
};

CybsStatusBadge.defaultProps = {
  size: 'small',
  icon: undefined,
  textOnly: false
};

export default CybsStatusBadge;
